export default {
  ERROR: 'scrubberError'
};
